import * as React from 'react';
import {Box} from "@mui/material";


export default function PageIccubeAdmin() {
    return <Box width={'100%'} height={'calc(100vh - 55px)'} overflow={'hidden'}>
        <iframe title="ic-admin" id="ic3-iframe" width={"100%"} height={"100%"} src={"/icCube/console/?ic3customHeaders=admin"}/>
    </Box>
}